define('app/sf/title/case/sf-title-case-filter',["factory!sf-title-case-ignore"], function (ignore) {
	"use strict";
	return sfTitleCaseFilter;
	function sfTitleCaseFilter(text) {
		return String(text).toLocaleLowerCase().replace(/\b[a-z][^\s]*/g, function (match, offset) {
			if (offset === 0 || !ignore(match)) {
				return match.charAt(0).toUpperCase() + match.slice(1);
			}
			else {
				return match;
			}
		});
	}
});
